'use strict';
import {module} from '../app';

module.controller('OptionsCtrl', [
  '$scope', 'techpadOptions', 'versionCheckService',
    function ($scope, techpadOptions, versionCheckService) {

      techpadOptions.getOptions();
      $scope.techpadOptions = techpadOptions.options;

      $scope.toggleDarkMode = function () {
        $scope.techpadOptions.DarkMode = !$scope.techpadOptions.DarkMode;
        techpadOptions.saveOptions();        
      };

      $scope.toggleTotalTimeDisplay = function () {
        $scope.techpadOptions.DisplayTotalTimePatientHasBeen = !$scope.techpadOptions.DisplayTotalTimePatientHasBeen;
        techpadOptions.saveOptions();
      };

      $scope.saveOptions = function () {
        techpadOptions.saveOptions();
        if(!$scope.techpadOptions.DarkMode && $('body').hasClass('dark-mode')){
          $('body').removeClass('dark-mode');
        }else if($scope.techpadOptions.DarkMode &&  !$('body').hasClass('dark-mode')){
          $('body').addClass('dark-mode');
        }
      };

      $scope.cleanUpData = function () {
        versionCheckService.reloadApplication(true, true);
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/options.js